import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BUTTON_STYLES, BUTTON_TYPES} from "../buttons/buttons.component";
import {ICON_SIZE} from "../utils";

@Component({
  selector: 'beaconstac-title',
  templateUrl: './titles.component.html',
  styleUrls: ['./titles.component.scss']
})
export class TitlesComponent {

  /**
   * Title text
   */
  @Input()
  title: string = '';

  /**
   * Icon after Title
   */
  @Input()
  icon: string = '';

  /**
   * Subtitle text
   */
  @Input()
  subtitle: string = '';

  @Input()
  mobileSubtitle = false;

  /**
   * Is secondary action button visible
   */
  @Input()
  secondaryAction: boolean;

  @Input()
  disableSecondaryButton: boolean;

  /**
   * Secondary action button title text
   */
  @Input()
  secondaryActionTitle: string = '';

  /**
   * Secondary action button icon
   */
  @Input()
  secondaryActionIcon: string = '';

  /**
   * Type of button for secondary action button
   */
  @Input()
  secondaryActionButtonType = BUTTON_TYPES.SECONDARY;

  /**
   * Style of button for secondary action button
   */
  @Input()
  secondaryActionButtonStyle = BUTTON_STYLES.FILLED;

  /**
   * Is primary action button visible
   */
  @Input()
  primaryAction: boolean;

  @Input()
  disablePrimaryButton: boolean;

  /**
   * Primary action button title text
   */
  @Input()
  primaryActionTitle = '';

  /**
   * Primary action button icon
   */
  @Input()
  primaryActionIcon = '';

  /**
   * Type of button for primary action button
   */
  @Input()
  primaryActionButtonType = BUTTON_TYPES.PRIMARY;

  /**
   * Style of button for primary action button
   */
  @Input()
  primaryActionButtonStyle = BUTTON_STYLES.FILLED;

  /**
   * Custom icon css for primary button
   */
  @Input()
  iconCssPrimaryAction: ICON_SIZE = ICON_SIZE.MEDIUM;

  /**
   * Use custom icon for primary button
   */
  @Input()
  useCustomImageIconPrimaryAction: boolean;

  /**
   * Custom icon css for secondary button
   */
  @Input()
  iconCssSecondaryAction: ICON_SIZE = ICON_SIZE.MEDIUM;

  /**
   * Use custom icon for secondary button
   */
  @Input()
  useCustomImageIconSecondaryAction: boolean;

  /**
   * Click event emitter for primary button
   */
  @Output()
  onClickPrimaryAction = new EventEmitter<Event>();

  /**
   * Click event emitter for secondary button
   */
  @Output()
  onClickSecondaryAction = new EventEmitter<Event>();

}
